export function getEntityLocation(entity) {
    if (!entity) {
        return "N/A";
    }
    
    if (entity.$entityType === 'Location') {
        return entity.name;
    }

    return entity.locationName;
}